import { NumFavs } from 'app/design/icons/num-favs';
import { NumViews } from 'app/design/icons/num-views';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

interface ListingCardAuthorStatsProps {
  numFavourites: number | undefined;
  numViews: number | undefined;
}

export function ListingCardAuthorStats({ numFavourites, numViews }: Readonly<ListingCardAuthorStatsProps>) {
  return (
    <Row alignItems="center" gap="spacing.general.x2" paddingVertical="spacing.general.x0,5">
      <Row alignItems="center">
        <NumViews />
        <Text fontSize={16} paddingLeft="spacing.general.x0,5" variant="bodyBase">
          {numViews}
        </Text>
      </Row>
      <Row alignItems="center">
        <NumFavs />
        <Text fontSize={16} paddingLeft="spacing.general.x0,5" variant="bodyBase">
          {numFavourites}
        </Text>
      </Row>
    </Row>
  );
}
